/**
 * @generated SignedSource<<c32d4c114e4f62296d947ede9c0fe2b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HolidaysGroupSelector_viewer$data = {
  readonly account: {
    readonly holidays_groups: ReadonlyArray<{
      readonly id: number;
      readonly name: string;
    }>;
    readonly id: number;
  };
  readonly " $fragmentType": "HolidaysGroupSelector_viewer";
};
export type HolidaysGroupSelector_viewer$key = {
  readonly " $data"?: HolidaysGroupSelector_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HolidaysGroupSelector_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HolidaysGroupSelector_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "order_by",
              "value": {
                "name": "asc"
              }
            }
          ],
          "concreteType": "holidays_groups",
          "kind": "LinkedField",
          "name": "holidays_groups",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": "holidays_groups(order_by:{\"name\":\"asc\"})"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "bd190b1963b5e2843ef1eeed2e15d188";

export default node;
